import React from "react";

const Profile = () => {
  return (
    <div>
      <h3>Profile</h3>
    </div>
  );
};

export default Profile;
